// extracted by mini-css-extract-plugin
export var buttonContainer = "_8g-1";
export var fontSizeSelect = "_8g-3";
export var formatSelect = "_8g-2";
export var formats = "_8g-4";
export var hidden = "_8g-5";
export var icon = "_8g-6";
export var select = "_8g-0";